module.exports = __webpack_public_path__ + "static/img/1.bfdea6b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/eng/1.png
// module id = HboG
// module chunks = 0